import type { ReactNode } from "react"

import styles from "./CheckerBoard.module.css"

export interface CheckerBoardProps {
  children?: ReactNode
}

export function CheckerBoard(props: CheckerBoardProps) {
  const { children } = props
  return <div className={styles.checkerboard}>{children}</div>
}
